import {ISvgIconProps, SvgIcon} from "../../../basic-ui-components/icon/svg-icon/svg.icon";
import * as React from "react";

export class OpenExternalIcon extends React.Component<ISvgIconProps> {

    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 24 24" >
                <g fill="currentColor">
                    <path d="M19.514,10.35v8.805c0,0.197-0.155,0.353-0.354,0.353H4.84c-0.198,0-0.353-0.155-0.353-0.353V4.845
                        c0-0.198,0.155-0.353,0.353-0.353h8.812V3.007H4.84C3.825,3.007,3,3.832,3,4.845v14.309c0,1.015,0.825,1.839,1.84,1.839h14.32
                        c1.015,0,1.84-0.824,1.84-1.839V10.35H19.514z"/>
                    <polygon points="9.776,13.14 10.827,14.191 18.642,6.375 20.917,8.649 20.917,8.634 20.917,3.076 15.344,3.076 17.592,5.324 	"/>
                </g>
           </SvgIcon>
        )
    }
}